<template>
  <div class="accomodation">
    <div class="accomodation-group">
      <h2>Accommodation Request</h2>
      <p>Please advise us if you require accommodation by answering the following questions</p>
    </div>
    <!-- Would you like accommodation -->
      <p>Would you like us to provide accommodation?</p>
      <b-form-group>
        <div class="radio radio-custom">
          <input id="provideAccommodationYes" 
            name="provideAccommodation"
            v-model="provideAccommodation"
            type="radio" 
            value="I would like Trailfinders to provide accommodation"
            @change="handleInput('provideAccommodation', provideAccommodation)"
          >
          <label for="provideAccommodationYes" >Yes</label>
        </div>
        <div class="radio radio-custom">
          <input id="provideAccommodationNo"
            name="provideAccommodation"
            v-model="provideAccommodation"
            type="radio" 
            value="I do not require Trailfinders to provide accommodation"
            @change="handleInput('provideAccommodation', provideAccommodation)"
          >
          <label for="provideAccommodationNo" >No</label>
        </div>
        <b-alert v-if="$v.form.provideAccommodation.$error" show variant="danger">
          <p>You must choose an option in order to submit the onboarding documents</p>
        </b-alert>
      </b-form-group>
      <!-- If candidate selects yes for accommodation -->
      <b-card v-if="provideAccommodation === 'I would like Trailfinders to provide accommodation' && cmCopy !== '' ">
          <h3>{{ cmCopy.title }}</h3>
          <p v-html="cmCopy.description "></p>
      </b-card>

      <!-- Do you give permission to pass on your number -->
      <p class="mt-4">Do we have permission to give your phone number to a fellow trainee? We will only pass your number on in emergency situations e.g your flatmate is unable to make it to Kensington in time to collect their keys.</p>
      <b-form-group>
        <div class="radio radio-custom">
          <input id="giveNumberYes" 
            name="giveNumber"
            v-model="giveNumber"
            type="radio"
            value="I am happy for my number to be passed on"
            @change="handleInput('giveNumber', giveNumber)"
          >
          <label for="giveNumberYes" >Yes</label>
        </div>
        <div class="radio radio-custom">
          <input id="giveNumberNo" 
            name="giveNumber"
            v-model="giveNumber"
            type="radio"
            value="I do not want my number to be passed on"
            @change="handleInput('giveNumber', giveNumber)"
          >
          <label for="giveNumberNo" >No</label>
        </div>
        <b-alert v-if="$v.form.giveNumber.$error" show variant="danger">
          <p>You must choose an option in order to submit the onboarding documents</p>
        </b-alert>
      </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { updateForm } from '../../helpers/index'
import { required } from 'vuelidate/lib/validators'
import { fetchManagedContent } from '../../services/api'
export default {
  computed: {
    ...mapState({form: state => state.authStore.recruit.onboarding.onboardingForms.accommodation}),
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getToken: 'authStore/getToken',
    })
  },
  data () {
    return {
      provideAccommodation: '',
      giveNumber: '',
      formName: 'accommodation',
      cmCopy: ''
    }
  },
  mounted () {
    this.$v.$touch()
    this.getCMCopy()
    setTimeout(() => {
      this.provideAccommodation = this.form.provideAccommodation
      this.giveNumber = this.form.giveNumber
    }, 1000)
  },
  updated () {
    // this.updateForm('valid', this.$v.$error)
    const validationData = {
      section: 'accommodation',
      status: !this.$v.form.$invalid
    }
    this.updateOnboardingCompleteAction(validationData)
  },
  methods: {
    ...mapActions({
      updateOnboardingFormAction: 'authStore/updateOnboardingFormAction',
      currentOnboardingFormAction: 'authStore/currentOnboardingFormAction',
      setRecruitAction: 'authStore/setRecruitAction',
      updateOnboardingCompleteAction: 'authStore/updateOnboardingCompleteAction'
    }),
    handleInput(input, e, nested, array, index, item) {
      this.updateForm(input, e, nested, array, index, item)
    },
    async getCMCopy() {
      let res = await fetchManagedContent(this.getToken,1)
      if (res && res.data) {
        this.cmCopy = res.data
      } 
    },
    updateForm
  },
  validations: {
    form: {
      provideAccommodation: {
        required: required
      },
      giveNumber: {
        required: required
      }
    }
  }
}
</script>

<style scoped>
.accommodation-group {
  margin: 3rem 0;
}
</style>
